<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch04"></a><a id="page_4"></a><a href="#/contents#ch04"><b>Talk Like a Pirate</b></a></h2>
<p class="noindenta"><span><b>THREATS</b></span></p>
<p class="noindent1"><span>Your sands are run!</span></p>
<p class="noindent1"><span><i>(I’m going to kill you!)</i></span></p>
<p class="noindent"><span>I’ll slit a couple of feet of steel into your vitals!</span></p>
<p class="noindent1"><span><i>(I’ll stab you with my sword!)</i></span></p>
<p class="noindent"><span>I come from hell, and I’ll carry you there presently.</span></p>
<p class="noindent1"><span><i>(How all good pirates answer the question “Where are you from?”)</i></span></p>
<p class="noindenta"><span><b>INSULTS</b></span></p>
<p class="noindent1"><span>You’re a dung-souled knuckle brain.</span></p>
<p class="noindent1"><span><i>(You’re an incapable idiot.)</i></span></p>
<p class="noindent"><span>You’ve got a split tongue.</span></p>
<p class="noindent1"><span><i>(You’re a liar.)</i></span></p>
<p class="noindent"><span>You should be fed on pap and suckets.</span></p>
<p class="noindent1"><span><i>(You’re acting like a baby. Pap and suckets were soft foods often served to babies.)</i></span></p>
<p class="noindent"><span>The smell of you alone is enough to wrinkle the noses of pigs.</span></p>
<p class="noindent1"><span><i>(You stink.)</i></span></p>
<p class="noindenta"><span><b>GENERAL DIRECTIONS</b></span></p>
<p class="noindent1"><span>“Scupper your hide out of here.”</span></p>
<p class="noindent1"><span>(<i>Go away.</i>)</span></p>
<p class="noindent"><span>Clap a stopper on your eyes.</span></p>
<p class="noindent1"><span><i>(Quit crying.)</i></span></p>
<p class="noindent"><span>Put a name on what you’re at.</span></p>
<p class="noindent1"><span><i>(What do you mean?)</i></span></p>
<p class="noindent"><span>Bestir yourself!</span></p>
<p class="noindent1"><span><i>(Move it!)</i></span></p>
<p class="noindent"><span>Cough up your tale.</span></p>
<p class="noindent1"><span><i>(Tell us your story.)</i></span></p>
<p class="noindent"><span>Keep your tongue behind your teeth.</span></p>
<p class="noindent1"><span><i>(Don’t say anything.)</i></span></p>
<p class="noindent"><span>Shiver your timbers.</span></p>
<p class="noindent1"><span><i>(Wait a minute.)</i></span></p>
<p class="noindent"><span>Stay your claws.</span></p>
<p class="noindent1"><span><i>(Keep your hands to yourself.)</i></span></p>
<p class="noindent"><span>Strike your colors.</span></p>
<p class="noindent1"><span><i>(Surrender.)</i></span></p>
<p class="noindent"><span>Cock your piece.</span></p>
<p class="noindent1"><span><i>(Get your gun ready.)</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter04.vue?3d40d489